import request from '@/utils/request'
const BASE_URL = '/GdCommon'

//成长性数据
export default {
    //获取待审核列表
    getReviewList(data) {
        return request({
            url: BASE_URL + '/GetReviewList',
            method: 'post',
            data
        })
    },
    //获取个人成长看台
    getPersonGrowData(data) {
        return request({
            url: BASE_URL + '/GetPersonGrowData',
            method: 'post',
            data
        })
    },
    getQueryGroupData(data) {
        return request({
            url: BASE_URL + '/GetQueryGroupData',
            method: 'post',
            data: data
        })
    },
    //导出个人成长看台
    exportPersonGrowData(data) {
        return request({
            url: BASE_URL + '/ExportPersonGrowData',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
    //获取成长活跃个人
    getRankData(data) {
        return request({
            url: BASE_URL + '/GetRankData',
            method: 'post',
            data
        })
    },
    //导出成长活跃个人
    exportRankData(data) {
        return request({
            url: BASE_URL + '/ExportRankData',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
    //获取专业成长数据统计
    getStatData(data) {
        return request({
            url: BASE_URL + '/GetStatData',
            method: 'post',
            data
        })
    },
    //导出专业成长数据统计
    exportStatData(data) {
        return request({
            url: BASE_URL + '/ExportStatData',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
    //获取学校教师结构
    getStructureData(data) {
        return request({
            url: BASE_URL + '/GetStructureData',
            method: 'post',
            data
        })
    },
    //导出学校教师结构
    exportStructureData(data) {
        return request({
            url: BASE_URL + '/ExportStructureData',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
    //获取超级查询数据
    getQueryData(data) {
        return request({
            url: BASE_URL + '/GetQueryData',
            method: 'post',
            data
        })
    },
    //导出超级查询数据
    exportQueryData(data) {
        return request({
            url: BASE_URL + '/ExportQueryData',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
    //导出超级查询明细数据
    exportQueryDataDetail(data) {
        return request({
            url: BASE_URL + '/ExportQueryDataDetail',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
    //导出超级组合查询数据
    exportQueryGroupData(data) {
        return request({
            url: BASE_URL + '//ExportQueryGroupData',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
    //导出超级查询明细数据
    exportQueryGroupDataDetail(data) {
        return request({
            url: BASE_URL + '/ExportQueryGroupDataDetail',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
}